import * as STD from '@emersya/mpa-std-lib';
import CM       from '@emersya/mpa-components-manager-lib';

export interface IInputFormComponentConfiguration extends IInputComponentConfiguration<
	STD.object.JSON,
	STD.object.JSON
>
{
};

export class InputFormComponent<
	TComponent extends InputFormComponent<TComponent, TConfiguration>,
	TConfiguration extends IInputFormComponentConfiguration
> extends InputComponent<
	HTMLFormElement | HTMLDivElement,
	STD.object.JSON,
	STD.object.JSON,
	TComponent,
	TConfiguration
>
{
	private static onSubmit(ev : SubmitEvent) {
		ev.preventDefault();
		//retrieve current InputFormComponent & dispatch value event
	};

	component_DOM : HTMLFormElement | HTMLDivElement;

	override deserialize(x : STD.object.JSON) {
		return (x);
	};

	async reset() {
		await this.updateValue(this.component_configuration.defaultValue || null);
	};

	private isAlreadyInForm() : boolean {
		for (let parent : CM.Component<any, any> = <any> this.component_parent; parent = <any> parent.component_parent; parent) {
			if (parent instanceof InputFormComponent) {
				return (true);
			}
		}
		return (false);
	};

	override isValueTheDefault() {
		return (false);
	};

	serialize() {
		return this.value;
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : TConfiguration
	)
	{
		super(descriptor, configuration);
		if (this.isAlreadyInForm()) {
			this.component_DOM = <HTMLDivElement> STD.DOM.factory({
				tag :    'div',
				events : {
					submit : InputFormComponent.onSubmit.bind(InputFormComponent)
				}
			});
		} else {
			this.component_DOM = <HTMLFormElement> STD.DOM.factory({
				tag :    'form',
				events : {
					submit : InputFormComponent.onSubmit.bind(InputFormComponent)
				}
			});
		}
	};
};
export namespace NS {
	export const Component = InputFormComponent;
	export type Component = InputFormComponent<any, any>;
	export type Configuration = IInputFormComponentConfiguration;
}
import './InputForm.scss';
import { InputComponent, IInputComponentConfiguration } from '../Input/Input';
import manifestXMLSource                                from './InputForm.xml';

CM.declare({
	id :       'input-form',
	type :     InputFormComponent,
	manifest : manifestXMLSource
});
